import React from "react";
import {Button, IconButton, Typography} from "@material-tailwind/react";
import {ChevronUpDownIcon} from "@heroicons/react/24/outline";

export function TableHead({
                            tableHead,
                            headSortable,
                            headMap,
                            sortType,
                            setSortType,
                            setSortBy,
                            selectedHead,
                            setSelectedHead
                          }) {

  const handle_sort = (head) => {
    if (headSortable[head] === true) {
      if (head === selectedHead) {
        setSortType(!sortType);
      } else {
        setSortType(false);
        setSortBy(headMap[head])
      }

      setSelectedHead(head)
    }
  }

  return (
    <thead className="w-full">
    <tr className="w-full">
      {tableHead.map((head) => (
        <th key={head}
            className="border-y border-blue-gray-100 bg-blue-gray-50/50 py-2">
          <div className="flex flex-row justify-center w-full">
            <Button className="cursor-pointer bg-transparent shadow-none"
                    type="text"
                    onClick={() => {
                      handle_sort(head);
                    }}>
              <Typography variant="small" color="blue-gray"
                          className="flex items-center  gap-2 font-normal leading-none textCenter"
              >
                {head}{" "}
              </Typography>
            </Button>
            {headSortable[head] &&
              <IconButton className="cursor-pointer bg-transparent shadow-none text-gray-900">
                <ChevronUpDownIcon strokeWidth={2} className="h-4 w-4 sticky"
                                   onClick={() => {
                                     handle_sort(head);
                                   }}
                />
              </IconButton>
            }
          </div>
        </th>
      ))}
    </tr>
    </thead>
  );
}